import React from 'react'

export const SelectInput = ({config, currentValue, onChange}) => {
  const options = config?.options || []

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <div className="custom-field-wrapper">
      <label className="custom-field-label">
        <span className="custom-field-label-text">{config?.label}</span>
        <select
          className="custom-field-select"
          value={currentValue}
          onChange={handleChange}
        >
          <option value="">Select an option</option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  )
}
